import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';
import { PROFICO_DOMAIN_ID } from '../constants/platform';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const teamService = {
  _url: process.env.REACT_APP_TEAM_API_URL,
  _domain_id: PROFICO_DOMAIN_ID,

  GetTeamList(searchQuery, fetch) {
    const [data, setsData] = useState({
      teams: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllTeam(searchQuery))
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: data,
    };
  },
  GetFilteredTeamList(searchQuery, fetch) {
    const [data, setsData] = useState({
      teams: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getFilteredTeamList(searchQuery))
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: data,
    };
  },

  async getAllTeam(searchQuery) {
    return await Fetch.get(
      `${this._url}/list?team_type=user_created&domain_id=${this._domain_id}`,
    );
  },

  async getTeamDetails(id) {
    return await Fetch.get(`${this._url}/details?team_id=${id}`);
  },

  async getFilteredTeamList(searchQuery) {
    const domain_id = searchQuery?.domain_id || this._domain_id;
    const team_type = searchQuery?.team_type || 'admin_created';
    return await Fetch.get(`${this._url}/list?domain_id=${domain_id}&team_type=${team_type}`);
  },

  async createTeam(payload) {
    return await Fetch.post(`${this._url}/create`, payload);
  },

  async updateTeam(payload) {
    return await Fetch.put(`${this._url}/update`, payload);
  },

  async deleteTeam(id) {
    return await Fetch.delete(`${this._url}/delete?team_id=${id}`);
  },
};

export default teamService;
